export default String.raw`
{% for da in customer.DeliveryAddresses -%}
	{% assign i = forloop.index0 -%}
    {% if da.Country != '' -%}
        {% assign daCountry = da.Country -%}
    {% else -%}
        {% assign daCountry = config.Countries[0].ISOCode -%}
    {% endif -%}
    {% capture inc -%}{{da.Id}}|{{daCountry}}{% endcapture -%}
    <div class="container-js container-to-delete-js {% if da.Default -%} active {% endif -%} {% if da.Name == '' -%} hidden-js {% endif -%}" data-include="{{inc}}">
        {% include 'partials/customer-profile/customer-details/delivery-address.html' with inc -%}
    </div>
{% endfor -%}
`